import { vpApi } from './vpApi'

export type DeploymentGroupActionResponse = {
  detail: string
  revision: number
}

const stopDeploymentGroup = async (groupId: string) => {
  const res = await vpApi.post<DeploymentGroupActionResponse>(
    `/v1/deployment-groups/${groupId}/stop/`
  )

  return res.data
}

const startDeploymentGroup = async (groupId: string) => {
  const res = await vpApi.post<DeploymentGroupActionResponse>(
    `/v1/deployment-groups/${groupId}/start/`
  )

  return res.data
}

const restartDeploymentGroup = async (groupId: string) => {
  const res = await vpApi.post<DeploymentGroupActionResponse>(
    `/v1/deployment-groups/${groupId}/restart/`
  )

  return res.data
}

const removeDeploymentGroup = (groupId: string) => {
  return vpApi.delete(`/v1/deployment-groups/${groupId}/`)
}

export const deploymentGroupApi = {
  stopDeploymentGroup,
  startDeploymentGroup,
  restartDeploymentGroup,
  removeDeploymentGroup
}
